export const NUMBER_TEST_ID = 'issue-field-number.ui.issue-field-number';
export const NUMBER_TEST_ID_WITH_INLINE_EDIT =
	'issue-field-number.ui.issue-field-number--container';
export const NUMBER_BADGE_TEST_ID = 'issue-field-number.ui.badge';
export const NUMBER_BADGE_HOVER_CONTAINER_TEST_ID = `${NUMBER_BADGE_TEST_ID}-hover-container`;
export const NUMBER_WARNING_ICON_TEST_ID = 'issue-field-number.edit.warning-icon';
